export const ATTACHMENT_UPLOAD_PROGRESS = 'ATTACHMENT_UPLOAD_PROGRESS';
export const ATTACHMENT_UPLOAD_START = 'ATTACHMENT_UPLOAD_START';
export const ATTACHMENT_UPLOAD_COMPLETE = 'ATTACHMENT_UPLOAD_COMPLETE';
export const REMOVE_ATTACHMENT = 'REMOVE_ATTACHMENT';
export const CLEAR_ATTACHMENTS = 'CLEAR_ATTACHMENTS';
export const ATTACHMENT_ERROR = 'ATTACHMENT_ERROR';
export const DISMISS_ATTACHMENTS_ERROR = 'DISMISS_ATTACHMENTS_ERROR';